export const PRESENTATION_DEFAULTS = {
    /** Scales runner playback, camera travel and inherited primitive timings, without compounding primitive-space speed. */
    animationDurationMultiplier: 3,
    cameraTransitionDurationMs: 700,
    minimumPositionIntervalMs: 16,
} as const;
